import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '../components/HeroSection';
import ConceptSection from '../components/ConceptSection';
import WhySection from '../components/WhySection';
import TreasuresSection from '../components/TreasuresSection';
import AdvantagesSection from '../components/AdvantagesSection';
import FreePhilosophySection from '../components/FreePhilosophySection';
import FaqSection from '../components/FaqSection';
import { initAnalytics, trackUserJourney } from '../utils/analytics';

const HomePage = () => {
  useEffect(() => {
    // Initialiser le tracking pour la page d'accueil
    const cleanup = initAnalytics('home_page');
    
    // Track user journey
    trackUserJourney('homepage_visit', 'discovery');
    
    return cleanup;
  }, []);

  return (
    <>
      <Helmet>
        <title>Sun Spot - Découvrez et partagez vos spots panoramiques préférés</title>
        <meta name="description" content="Sun Spot : découvrez les plus beaux spots panoramiques, bancs avec vue et lieux secrets. Plateforme gratuite pour trouver des points de vue exceptionnels et endroits calmes près de chez vous." />
        <link rel="canonical" href="https://sun-spot.app/" />
        <meta property="og:url" content="https://sun-spot.app/" />
        <meta property="og:title" content="Sun Spot - Découvrez les plus beaux spots panoramiques" />
        <meta property="og:description" content="Sun Spot : découvrez des spots panoramiques exceptionnels, bancs avec vue et lieux secrets pour contempler. Plateforme gratuite de partage de points de vue." />
      </Helmet>
      
      <HeroSection />
      <ConceptSection />
      <WhySection />
      <TreasuresSection />
      <AdvantagesSection />
      <FreePhilosophySection />
      <FaqSection />
    </>
  );
};

export default HomePage;